/**
 * @module host
 */

import React from 'react';
import {Application} from './';
import {fromFrame} from './MessageTransport';

export interface FrameProps {
  app: Application;
  title: string;
  url: string;
  [key: string]: any;
}

export class Frame extends React.PureComponent<FrameProps, never> {
  iframe?: HTMLIFrameElement;
  detach?: Function;

  componentDidMount() {
    const {url} = this.props;
    const frameOrigin = new URL(url).origin;
    if (this.iframe) {
      const transport = fromFrame(this.iframe, frameOrigin);
      this.detach = this.props.app.attach(transport);
    }
  }

  componentWillUnmount() {
    if (this.detach) {
      this.detach();
    }
  }

  render() {
    const {app, title, url, ...props} = this.props;

    return (
      <iframe
        title={title}
        src={url}
        {...props}
        ref={element => (element ? (this.iframe = element) : undefined)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/host/Frame.tsx